<script>
	import Navbar from "../Navbar.svelte";
	import Footer from "../components/Footer.svelte";
	import { handleSubmit, parseFormdata, updateNextRoute } from "../utils.js";
	import { api_writeForm, disableNextButton } from "../stores.js";
	import { useForm, validators, required } from "svelte-use-form";
	// https://svelte.dev/repl/d4fc021f688d4ad0b3ceb9a1c44c9be9?version=3.34.0

	export let redirectRoute;
	updateNextRoute();
	redirectRoute = localStorage.getItem("nextRoute");
	const form = useForm();

	const handleClick = () => {
		handleSubmit($api_writeForm, parseFormdata($form), redirectRoute);
	};

	let monkeypoxfields = [
		// monkeypoxworry
		{
			labelName: "monkeypox-worry",
			label: "How worried are you about Monkeypox?",
			options: [
				{
					type: "radio",
					value: "6_extremely-worried", // value/response to send to server
					option: "Extremely worried", // what to display
				},
				{
					type: "radio",
					value: "5_very-worried",
					option: "Very worried",
				},
				{
					type: "radio",
					value: "4_moderately-worried",
					option: "Moderately worried",
				},
				{
					type: "radio",
					value: "3_somewhat-worried",
					option: "Somewhat worried",
				},
				{
					type: "radio",
					value: "2_slighly-worried",
					option: "Slightly worried",
				},
				{
					type: "radio",
					value: "1_not-at-all-worried",
					option: "Not at all worried",
				},
			],
		},

		// monkeypoxconcern
		{
			labelName: "monkeypox-concern",
			label: "How concerned are you about Monkeypox?",
			options: [
				{
					type: "radio",
					value: "6_extremely-concerned", // value/response to send to server
					option: "Extremely concerned", // what to display
				},
				{
					type: "radio",
					value: "5_very-concerned",
					option: "Very concerned",
				},
				{
					type: "radio",
					value: "4_moderately-concerned",
					option: "Moderately concerned",
				},
				{
					type: "radio",
					value: "3_somewhat-concerned",
					option: "Somewhat concerned",
				},
				{
					type: "radio",
					value: "2_slighly-concerned",
					option: "Slightly concerned",
				},
				{
					type: "radio",
					value: "1_not-at-all-concerned",
					option: "Not at all concerned",
				},
			],
		},

		// monkeypoxvax
		{
			labelName: "monkeypox-vax",
			label: "If it were recommended that everyone gets vaccinated against monkeypox and that the vaccine was available at no cost, how likely would you be to get it?",
			options: [
				{
					type: "radio",
					value: "5_absolutely-likely",
					option: "Absolutely likely",
				},
				{
					type: "radio",
					value: "4_very-likely",
					option: "Very likely",
				},
				{
					type: "radio",
					value: "3_somewhat-likely",
					option: "Somewhat likely",
				},
				{
					type: "radio",
					value: "2_not-likely",
					option: "Not likely",
				},
				{
					type: "radio",
					value: "1_never",
					option: "Never",
				},
			],
		},

		// monkeypoxproblem
		{
			labelName: "monkeypox-problem",
			label: "Monkeypox is a serious problem.",
			options: [
				{
					type: "radio",
					value: "6_strongly-agree", // value/response to send to server
					option: "Strongly agree", // what to display
				},
				{
					type: "radio",
					value: "5_agree",
					option: "Agree",
				},
				{
					type: "radio",
					value: "4_slightly-agree",
					option: "Slightly agree",
				},
				{
					type: "radio",
					value: "3_slightly-disagree",
					option: "Slightly disagree",
				},
				{
					type: "radio",
					value: "2_disagree",
					option: "Disagree",
				},
				{
					type: "radio",
					value: "1_strongly-disagree",
					option: "Strongly disagree",
				},
			],
		},
	];

	let fields = monkeypoxfields;

	// reverse options (high to low)
	//fields.forEach((field) => {
	//	field.options.reverse();
	//});

	// fields = fields.slice(fields.length - 2, fields.length);
</script>

<Navbar />

<section>
	<h1>Monkeypox attribution and concern</h1>
	<form use:form>
		{#each fields as field, fi}
			<div class="field-container">
				<label for={field.labelName}>{@html field.label} </label>
				{#each field.options as option, oi}
					<div class="option-group">
						<input
							name={field.labelName}
							type={option.type}
							value={option.value}
							use:validators={[required]}
						/>
						<span class="option"> {@html option.option} </span>
					</div>
				{/each}
			</div>
		{/each}

		<button
			disabled={!$form.valid && $disableNextButton}
			on:click|preventDefault={handleClick}>Next</button
		>
	</form>
</section>

<Footer />

<style>
	@media (max-width: 700px) {
		section {
			padding-left: 8%;
			padding-right: 8%;
		}
	}

	button {
		margin-bottom: 144px;
	}

	label {
		margin-bottom: 13px;
		font-size: 1.1em;
	}

	input {
		margin-right: 1px;
	}

	.field-container {
		margin-bottom: 34px;
	}

	.option {
		margin-right: 13px;
	}

	.option-group {
		display: inline;
	}

	@media (max-width: 1597px) {
		.option-group {
			display: block;
		}
	}
</style>
